var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { isSubtreeDirty } from './bounds';
/** Offscreen bitmap cache for static subtrees. */
var LayerCache = /** @class */ (function () {
    function LayerCache() {
        this.entries = new Map();
    }
    LayerCache.prototype.get = function (group) {
        return this.entries.get(group.id);
    };
    LayerCache.prototype.set = function (group, entry) {
        this.entries.set(group.id, entry);
    };
    LayerCache.prototype.invalidate = function (nodeId) {
        this.entries.delete(nodeId);
    };
    LayerCache.prototype.invalidateSubtree = function (group) {
        var e_1, _a;
        this.entries.delete(group.id);
        try {
            for (var _b = __values(group.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if ('children' in child)
                    this.invalidateSubtree(child);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    LayerCache.prototype.isValid = function (group) {
        var entry = this.entries.get(group.id);
        if (!entry)
            return false;
        if (isSubtreeDirty(group))
            return false;
        var b = group.getBounds();
        return entry.width >= b.width && entry.height >= b.height;
    };
    LayerCache.prototype.clear = function () {
        this.entries.clear();
    };
    LayerCache.prototype.destroy = function () {
        this.clear();
    };
    return LayerCache;
}());
export { LayerCache };
